// extracted by mini-css-extract-plugin
export var infoItem = "_u6-2";
export var title = "_u6-0";
export var value = "_u6-1";